import { motion } from "framer-motion";
import { IoIosArrowBack } from "react-icons/io";
import { FiUpload } from "react-icons/fi";
import { useEffect } from "react";
import FileService from "../../../../services/file";

export default function Step2({ formData, setFormData, errors, setImage }) {

  async function uploadImage(file) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await FileService.uploadFile(formData);
      const res = response && response.data ? response.data : response;

      const idCandidates = [
        res?.message?.id,
        res?.message?._id,
        res?.data?._id,
        res?.data?.id,
        res?._id,
        res?.id,
      ];

      for (const cand of idCandidates) {
        if (cand !== undefined && cand !== null) return cand;
      }

      if (typeof res === "string" || typeof res === "number") return res;

      console.warn("uploadImage: unexpected upload response shape:", res);
      return null;
    } catch (error) {
      console.error("Error uploading image:", error);
      return null;
    }
  }
  const container = {
    hidden: { opacity: 0, y: 8 },
    show: {
      opacity: 1,
      y: 0,
      transition: { staggerChildren: 0.08, when: "beforeChildren" },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 6 },
    show: { opacity: 1, y: 0 },
  };

  useEffect(() => {
    if (!formData.images || formData.images.length < 5) {
      const newImages = formData.images ? [...formData.images] : [];
      while (newImages.length < 5) newImages.push(null);
      setFormData({ ...formData, images: newImages });
    }
  }, [formData.images]);

  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const files = formData.images ? [...formData.images] : [];
    files[index] = file;
    setFormData({ ...formData, images: files });

    try {
      const uploadedId = await uploadImage(file);

      setImage((prev = []) => {
        const ids = Array.isArray(prev) ? [...prev] : [];
        while (ids.length < files.length) ids.push(null);
        ids[index] = uploadedId;
        return ids;
      });
    } catch (err) {

      console.error("Failed to upload image for index", index, err);
      setImage((prev = []) => {
        const ids = Array.isArray(prev) ? [...prev] : [];
        while (ids.length < files.length) ids.push(null);
        ids[index] = null;
        return ids;
        
      });
    }
  };

  const handleAddMoreImages = () => {
    const newImages = [...formData.images, null];
    setFormData({ ...formData, images: newImages });
  };

  return (
    <motion.section
      className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"
      variants={container}
      initial="hidden"
      animate="show"
      exit="hidden"
      dir="rtl"
    >
      {/* هدر */}
      <motion.div
        variants={item}
        className="flex flex-row justify-between w-full h-max"
      >
        <img
          className="w-[80px] object-contain"
          src="/icon-512.png"
          alt="logo"
        />
        
      </motion.div>

      <motion.p
        variants={item}
        className="block text-gray-500 text-sm lg:w-1/2 w-full leading-relaxed"
      >
        برای ثبت آگهی جدید نیاز به اطلاعاتی جهت ارائه خدمات بهتر برای ثبت بار به شما داریم
        <br />
        قابل توجه شما : تضمین حفظ اطلاعات شما با بارسرا می باشد !
      </motion.p>

      <motion.div
        variants={item}
        className="flex flex-row justify-start items-center gap-5 h-max w-full"
      >
        <div className="h-[40px] w-[10px] rounded-lg bg-special" />
        <p className="text-gray-500 text-md lg:text-2xl font-bold">
          لطفا عکس های آگهی مورد نظر را وارد کنید
        </p>
      </motion.div>

      <motion.div
        variants={item}
        className="grid grid-cols-2 md:grid-cols-5 md:px-14 w-full mt-5"
      >
        {(formData.images || []).map((file, index) => {
          const label = `عکس ${index + 1}`;
          return (
            <div className="flex flex-col justify-center items-center gap-2 p-2">
            <label
              key={index}
              className="flex flex-col justify-center items-center border-2 bg-gray-100 border-gray-300 rounded-3xl h-[130px] w-full max-w-[170px] cursor-pointer hover:border-special transition-all duration-200"
            >
              {file ? (
                <img
                  src={URL.createObjectURL(file)}
                  alt={label}
                  className="h-full w-full object-cover rounded-lg"
                />
              ) : (
                <>
                  <FiUpload className="text-gray-400" size={28} />
                </>
              )}
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleFileChange(e, index)}
              />
              
            </label>
            <span className="text-xs text-gray-500 mt-2">{label}</span>
            </div>
          );
        })}
      </motion.div>

      <motion.div
        variants={item}
        className="flex flex-row justify-start items-center gap-2 text-special cursor-pointer hover:underline mt-4"
        onClick={handleAddMoreImages}
      >
        <span className="text-lg">+</span>
        <p className="text-sm">نیاز به آپلود عکس‌های بیشتر دارم</p>
      </motion.div>

      {/* خطا */}
      {errors.images && (
        <span className="text-red-500 text-xs">{errors.images}</span>
      )}
    </motion.section>
  );
}
